// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"df938b390094a0e2f318","342":"a8bf3d7d21a5538b0e90"}[chunkId] + ".js";
};